/* global BigInt */
import { CRC8, CRC8_POLY } from './crc8';
import { lightFormat, parseISO, isValid } from 'date-fns';
import { APP_CONFIG, controller_t, datetimeFormats, modelTypeDetails, modelTypeDetails_no_SWC } from '../constants';
import { devLog } from './devLog';

export const getUIDFromDb = (recordID) => {
  var built_UID = recordID;

  if (undefined !== built_UID) {
    if (built_UID.startsWith('UID')) {
      built_UID = built_UID.substring(4, 21);
    }
    // built_UID.replace( \|+$/g, '');
    while (built_UID.charAt(built_UID.length - 1) === '_') {
      built_UID = built_UID.substring(0, built_UID.length - 1);
    }
  }
  // console.log ( "Built_UID:; ",built_UID);
  //  464142203461
  //  46414220346172531

  return built_UID;
};

// var toggler = 0;

export const getShortIDFromUID = (UID) => {
  var built_UID1 = '0x' + getMacAddressFromUID(UID);
  let built_UID = BigInt(built_UID1).toString(10);
  // if ( ++toggler %251 == 0)
  // {
  //   console.log ( "getShortIDFromUID", UID, built_UID1, built_UID);
  // }
  return built_UID;
};

export const getIDSFromDb = (recordID) => {
  var built_long_UID = getUIDFromDb(recordID);
  var built_short_UID = getShortIDFromUID(built_long_UID);
  return { shortUID: built_short_UID, longUID: built_long_UID };
};

export const getRecordIDFromUIDWithDate = (value) => {
  var built_recordID = 'UID_';
  if (undefined !== value) {
    built_recordID += value + '_' + getDateTimeForRecordID();
  }
  //console.log ( "built_recordID:; ",built_recordID);
  //  464142203461
  //  46414220346172531

  return built_recordID;
};

export const getRecordIDFromUIDNoDT = (value) => {
  var built_recordID = 'UID_';
  if (undefined !== value) {
    built_recordID += value;
  }
  // console.log ( "built_recordID:; ",built_recordID);
  return built_recordID;
};

export const getRecordIDFromUID = (value) => {
  var built_recordID = 'UID_';
  if (undefined !== value) {
    built_recordID += value + '_DT_XXXX';
  }
  // console.log ( "built_recordID:; ",built_recordID);
  //  464142203461
  //  46414220346172531

  return built_recordID;
};

export const getDateTimeForRecordID = () => {
  var builtDateTime = 'DT_'; // 2023-07-27T22:32:09.096Z
  try {
    let curr_date = new Date().toISOString();
    builtDateTime = builtDateTime + curr_date;
  } catch (error) {
    devLog('could not convert time date correctly');
  }

  return builtDateTime;
};

export const getDateTimeFromRecordID_DEBUG = (recordID) => {
  var builtDateTime = getDateTimeFromRecordID(recordID); // 2023-07-27T22:32:09.096Z
  if (builtDateTime === undefined) {
    devLog('date time undefined');
  } else {
    devLog(
      'get date time: ',
      recordID,
      ' built: ',
      builtDateTime,
      ' LF: ',
      lightFormat(builtDateTime, datetimeFormats.mid),
    );
  }
  return builtDateTime;
};

export const getDateTimeFromRecordID = (recordID) => {
  var builtDateTime = undefined; // 2023-07-27T22:32:09.096Z
  if (recordID !== undefined) {
    try {
      var myRecordSplut = recordID.split('DT_')[1];
      //console.log( myRecordSplut)
      var parsedDateTime = parseISO(myRecordSplut);
      if (isValid(parsedDateTime)) {
        builtDateTime = parsedDateTime;
      }
    } catch (error) {
      devLog(' could not get time date from recordID', recordID);
    }
  }
  return builtDateTime;
};

export const getMacAddressFromUID = (UID) => {
  var mac = 0;
  if (UID !== undefined) {
    // A recordID that isn't a valid UID-based numeric string (malformed/
    // legacy data, or any DB record whose recordID never matched this
    // scheme) makes BigInt() throw. Every caller of getMacAddressFromUID/
    // getShortIDFromUID/getIDSFromDb ends up here, so guarding at the
    // source protects them all instead of requiring a try/catch at each
    // call site individually.
    try {
      let hexString = BigInt(getUIDFromDb(UID)).toString(16).padStart(14, '0');
      mac = hexString.substring(0, 12);
    } catch (error) {
      devLog('getMacAddressFromUID: could not parse UID', UID, error);
    }
  }
  return mac;
};

function convertToHexString(integer) {
  var str = Number(integer).toString(16);
  return str.length === 1 ? '0' + str : str;
}

export const encode_mac_address = (topicString, controllerType) => {
  var encoded;
  var sting = String(topicString);
  var byte_array = sting.split('').map(function (x) {
    return x.charCodeAt(0);
  });
  var crc_poly = CRC8_POLY.AQUATEK;

  const modelTypes = APP_CONFIG.SWC_ENABLED ? modelTypeDetails : modelTypeDetails_no_SWC;
  const themodel = modelTypes.find((model) => model.value === controllerType);
  if (themodel !== undefined) {
    crc_poly = themodel.crc_value;
  }

  var crc8 = new CRC8(crc_poly, 0);
  var checksum = crc8.checksum(byte_array);
  let crc_hex_string = convertToHexString(checksum);
  let combined_string = '0x' + topicString + crc_hex_string;
  var int2_value = BigInt(combined_string); //, radix: 16) ?? 0
  encoded = String(int2_value).padStart(17, '0');
  //  console.log ( "encode mac address:", controllerType, topicString, checksum, combined_string, encoded, "int", int2_value);
  return encoded;
};

export const getModelTypeValueFromUID = (UID) => {
  var controllerType = controller_t.NONE;
  var macAddrString = getMacAddressFromUID(UID);
  var typeStr = 'None';

  var result = false;
  modelTypeDetails.every((theModel) => {
    result = true;
    // RECLAIM is kept in modelTypeDetails for completeness (labeling a
    // device that already self-reports modelType "Reclaim" via its own
    // INFO record), but must never be resolved *from* a UID —
    // owner-confirmed 2026-07-16 that no real Reclaim device is added via
    // QR/UID scan, so decoding a UID to RECLAIM here would only ever be a
    // false-positive CRC8 poly collision, not a real one.
    if (theModel.value !== controller_t.NONE && theModel.value !== controller_t.RECLAIM) {
      const encodedStr = encode_mac_address(macAddrString, theModel.value);
      if (encodedStr === UID) {
        controllerType = theModel.value;
        typeStr = theModel.label;
        result = false;
      }
    }
    return result;
  });
  return { type: controllerType, string: typeStr };
};

// export const speedHasElementSID = (arr, shortID) => arr.some(el => el.shortDeviceId === shortID);

export const hasElement = (arr, shortID) => arr.some((el) => getIDSFromDb(el.recordID).shortUID === shortID);

export const speedHasElement = (arr, uniqueDeviceId) => arr.some((el) => el.uniqueDeviceId === uniqueDeviceId);

export const findShortUIDInListWithShortRecordID = (UIDToFind, listItemstoCheck) => {
  let ShortID = getShortIDFromUID(UIDToFind);
  return listItemstoCheck.filter((element) => getIDSFromDb(element.recordID).shortUID === ShortID);
};

export const findUIDInListWithRecordID = (UIDToFind, listItemstoCheck) => {
  return listItemstoCheck.filter((element) => getUIDFromDb(element.recordID) === UIDToFind);
};

export const findUIDInListWithUIDS = (UIDToFind, listItemstoCheck) => {
  return listItemstoCheck.filter((element) => element.UID === UIDToFind);
};

export function ExtractString(text, delimiter) {
  const extractStringUntilDelimiter = (text, delimiter) => {
    const index = text.lastIndexOf(delimiter);
    return index === -1 ? text : text.substring(index + 1);
  };
  var result = '';
  if (text !== undefined && text !== null) {
    result = extractStringUntilDelimiter(text, delimiter);
  }
  // console.log("ExtractString", text, delimiter, result);
  return result;
}
